import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/IconCard/IconCard.module.scss';
import React from 'react';

interface IconCardProps {
    icon: IconProp;
    title: string;
    backgroundColor: string;
    className?: string;
    onClick?: () => void;
}

export const IconCard: React.FC<IconCardProps> = ({ icon, title, backgroundColor, className, onClick }) => {
    return (
        <div
            className={clsx(styles.root, className)}
            onClick={onClick}
        >
            <div
                className={styles.icon}
                style={{ backgroundColor }}
            >
                <FontAwesomeIcon icon={icon} />
            </div>

            <p className={styles.title}>{title}</p>
        </div>
    );
};
